import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const privacyContent = <div className="space-y-4" data-id="element-100">
      <h3 className="text-lg font-bold text-navy-900" data-id="element-101">
        1. Recopilación de Información
      </h3>
      <p data-id="element-102">
        En Sueño Profundo Hormonal, respetamos su privacidad. Solo recopilamos
        la información necesaria para procesar su pedido y entregarle la guía
        digital. Esto incluye su nombre, dirección de correo electrónico y
        detalles de pago procesados de forma segura.
      </p>

      <h3 className="text-lg font-bold text-navy-900" data-id="element-103">
        2. Uso de la Información
      </h3>
      <p data-id="element-104">
        Utilizamos su información para enviarle el producto digital,
        proporcionarle soporte al cliente y enviarle actualizaciones relevantes
        sobre el producto. No vendemos ni compartimos sus datos personales con
        terceros con fines comerciales.
      </p>

      <h3 className="text-lg font-bold text-navy-900" data-id="element-105">3. Seguridad</h3>
      <p data-id="element-106">
        Implementamos medidas de seguridad estándar de la industria para
        proteger sus datos. Todas las transacciones de pago se realizan a través
        de pasarelas de pago seguras y encriptadas.
      </p>

      <h3 className="text-lg font-bold text-navy-900" data-id="element-107">4. Cookies</h3>
      <p data-id="element-108">
        Utilizamos cookies esenciales para mejorar su experiencia de navegación
        y analizar el tráfico del sitio web de forma anónima para mejorar
        nuestros servicios.
      </p>

      <h3 className="text-lg font-bold text-navy-900" data-id="element-109">5. Contacto</h3>
      <p data-id="element-110">
        Si tiene preguntas sobre nuestra política de privacidad, puede
        contactarnos a través de nuestro correo de soporte.
      </p>
    </div>;
  const termsContent = <div className="space-y-4" data-id="element-111">
      <h3 className="text-lg font-bold text-navy-900" data-id="element-112">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-113">
        Al acceder y utilizar este sitio web y comprar nuestros productos
        digitales, usted acepta estar legalmente vinculado por estos términos y
        condiciones.
      </p>

      <h3 className="text-lg font-bold text-navy-900" data-id="element-114">
        2. Propiedad Intelectual
      </h3>
      <p data-id="element-115">
        Todo el contenido incluido en la guía "Sueño Profundo Hormonal",
        incluyendo textos, gráficos, logos y templates, es propiedad exclusiva
        de Sueño Profundo Hormonal y está protegido por las leyes de propiedad
        intelectual. La compra le otorga una licencia personal e intransferible
        para uso privado. Está prohibida su reproducción, distribución o venta.
      </p>

      <h3 className="text-lg font-bold text-navy-900" data-id="element-116">
        3. Política de Reembolso
      </h3>
      <p data-id="element-117">
        Ofrecemos una garantía de satisfacción de 7 noches. Si después de
        aplicar los métodos descritos en la guía durante 7 noches no experimenta
        una mejora en su descanso, puede solicitar un reembolso completo
        contactando a nuestro equipo de soporte dentro de los 14 días
        posteriores a la compra.
      </p>

      <h3 className="text-lg font-bold text-navy-900" data-id="element-118">
        4. Descargo de Responsabilidad Médica
      </h3>
      <p data-id="element-119">
        Este producto es una guía educativa y de bienestar. No sustituye el
        consejo, diagnóstico o tratamiento médico profesional. Siempre consulte
        a su médico antes de comenzar cualquier nueva rutina de salud,
        especialmente si tiene condiciones médicas preexistentes.
      </p>

      <h3 className="text-lg font-bold text-navy-900" data-id="element-120">5. Modificaciones</h3>
      <p data-id="element-121">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios entrarán en vigor inmediatamente después de su
        publicación en el sitio web.
      </p>
    </div>;
  return <footer className="bg-navy-950 text-navy-400 py-12 text-center text-sm border-t border-navy-900" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4" data-id="element-123">
        <div className="flex flex-row justify-center items-center gap-4 md:gap-8 mb-6" data-id="element-124">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-gold-500 transition-colors underline decoration-navy-800 hover:decoration-gold-500 underline-offset-4" data-id="element-125">
            Políticas de Privacidad
          </button>
          <span className="text-navy-700" data-id="element-126">•</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-gold-500 transition-colors underline decoration-navy-800 hover:decoration-gold-500 underline-offset-4" data-id="element-127">
            Términos
          </button>
        </div>

        <p className="text-navy-500" data-id="element-128">
          © 2026 Sueño Profundo Hormonal. Todos los derechos reservados.
        </p>

        <p className="mt-6 text-xs text-navy-600 max-w-2xl mx-auto leading-relaxed" data-id="element-129">
          Aviso: El contenido de este sitio es solo con fines informativos y no
          pretende reemplazar el consejo, diagnóstico o tratamiento médico
          profesional. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta.
        </p>

        <p className="mt-4 text-xs text-navy-600 max-w-2xl mx-auto leading-relaxed" data-id="element-130">
          Este sitio no forma parte del sitio web de Facebook ni de Facebook
          Inc. Además, este sitio NO está respaldado por Facebook de ninguna
          manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>

      {/* Modals */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Políticas de Privacidad" data-id="element-131">
        {privacyContent}
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Uso" data-id="element-132">
        {termsContent}
      </LegalModal>
    </footer>;
}